import { READY, type Pose } from "pixelfx";

/**
 * Позы временного бойца — скелета pixelfx 24×38 (ADR 0002, способ В). Только то, что отличается от стойки
 * READY; поля и как работает тело — vendor/pixelfx/src/core/poses.js. У ударов две позы: замах и удар.
 */
export interface AttackPose {
  readonly windup: Pose;
  readonly strike: Pose;
}

const pose = (fields: Pose): Pose => ({ ...READY, ...fields });

export const STANCE = pose({});
export const CROUCH = pose({ crouch: 10, fx: 10, fy: -18, bx: 9, by: -17 });
export const BLOCK = pose({ fx: 9, fy: -30, bx: 11, by: -28, lean: -2 });
export const CROUCH_BLOCK = pose({ crouch: 10, fx: 9, fy: -22, bx: 11, by: -20 });
export const JUMP = pose({ crouch: 5, ffx: 5, ffy: -8, fbx: -2, fby: -10 });
export const HITSTUN = pose({ lean: -6, fx: 2, fy: -24, bx: 4, by: -22, crouch: 2 });
export const AIR_HIT = pose({ lean: -8, fx: -4, fy: -32, bx: 2, by: -34, ffx: 8, ffy: -8, fbx: -6, fby: -4 });
export const GETUP = pose({ crouch: 12, fx: 6, fy: -4, bx: 10, by: -6 });
export const VICTORY = pose({ crouch: 0, fx: -2, fy: -36, bx: 4, by: -38, turn: 1 });
export const LYING = pose({ crouch: 0, lean: 0, fx: -2, fy: -14, bx: 4, by: -15, ffx: -1, fbx: 2 });

export const ATTACK_POSES: Readonly<Record<string, AttackPose>> = {
  jab: { windup: pose({ fx: 8, fy: -25 }), strike: pose({ fx: 17, fy: -27, lean: 2 }) },
  hook: { windup: pose({ bx: 2, by: -26, lean: -2 }), strike: pose({ bx: 17, by: -28, lean: 4 }) },
  lightKick: { windup: pose({ ffx: 4, ffy: -6 }), strike: pose({ ffx: 16, ffy: -12, lean: -3 }) },
  heavyKick: { windup: pose({ ffx: -2, ffy: -10, lean: 3 }), strike: pose({ ffx: 18, ffy: -22, lean: -6, crouch: 0 }) },
  uppercut: { windup: pose({ crouch: 9, fx: 6, fy: -12 }), strike: pose({ fx: 10, fy: -40, crouch: 0, lean: -2 }) },
  crouchJab: { windup: pose({ crouch: 10, fx: 8, fy: -18 }), strike: pose({ crouch: 10, fx: 17, fy: -16 }) },
  sweep: {
    windup: pose({ crouch: 12, ffx: 4 }),
    strike: pose({ crouch: 13, ffx: 20, ffy: -1, lean: 3, fx: -4, fy: -6 }),
  },
  airKick: { windup: JUMP, strike: pose({ crouch: 2, ffx: 14, ffy: -10, fbx: -2, fby: -8 }) },
  airHeavy: { windup: JUMP, strike: pose({ ffx: 16, ffy: -16, lean: -5, fbx: -3, fby: -9 }) },
  dashStrike: {
    windup: pose({ crouch: 6, lean: 6, fx: 4, fy: -22 }),
    strike: pose({ lean: 6, fx: 18, fy: -26, ffx: 12, fbx: -12 }),
  },
  flip: {
    windup: pose({ crouch: 8, lean: 9, fx: 8, fy: -14, bx: 9, by: -13, ffx: 5, ffy: -9, fbx: 3, fby: -8 }),
    strike: pose({ lean: 8, ffx: 8, ffy: -2, fbx: 6, fby: -1, fx: -6, fy: -30, bx: -4, by: -32 }),
  },
  blink: {
    windup: pose({ crouch: 4, fx: -2, fy: -34, bx: 4, by: -34 }),
    strike: pose({ crouch: 4, fx: -2, fy: -34, bx: 4, by: -34 }),
  },
  vanish: {
    windup: pose({ crouch: 6, fx: 2, fy: -12, bx: 6, by: -12 }),
    strike: pose({ crouch: 6, fx: 2, fy: -12, bx: 6, by: -12 }),
  },
};
